<template>
  <div class="row">
    <div class="col-xl-5 mb-4 mb-xl-0">
      <div class="card pronunciation-preview-card h-100">
        <div class="card-body">
          <div class="section-heading mb-4">Bài học viên</div>

          <div class="preview-panel h-100">
            <div class="preview-panel__title">Thông tin bài</div>
            <div class="preview-panel__body">
              <!-- <p class="mb-2"><span class="font-weight-bold">Kỹ năng:</span> {{ currentHomework && currentHomework.skill }}</p>
              <p class="mb-2"><span class="font-weight-bold">Năng lực:</span> {{ currentHomework && currentHomework.capacity }}</p> -->
              <p class="mb-3 preview-script">
                <span class="font-weight-bold">Câu hỏi:</span>
                {{ currentHomework && currentHomework.group_question && currentHomework.group_question.description }}
              </p>

              <div class="preview-panel__title mt-4">Bài làm</div>
              <div class="media-wrap">
                <audio v-if="mediaType === 'audio'" class="w-100" controls preload="auto">
                  <source :src="currentHomework && currentHomework.student_answer" type="audio/ogg">
                  <source :src="currentHomework && currentHomework.student_answer" type="audio/mpeg">
                </audio>
                <video v-else-if="mediaType === 'video'" class="media-player" controls preload="auto">
                  <source :src="currentHomework && currentHomework.student_answer" type="video/mp4">
                  <source :src="currentHomework && currentHomework.student_answer" type="video/ogg">
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-7">
      <div class="card pronunciation-score-card">
        <div class="card-body">
          <div class="section-heading mb-4">Chấm bài</div>

          <div class="score-box">
            <div class="d-flex flex-column flex-lg-row align-items-lg-start justify-content-between mb-3">
              <div class="pr-lg-3 mb-3 mb-lg-0">
                <div class="score-box__label">
                  Điểm toàn bài <span class="text-danger">*</span>
                </div>
                <div class="score-box__hint">Nhập điểm và nhận xét tổng quan cho bài pronunciation</div>
              </div>

              <div class="score-box__rate">
                <el-rate
                  class="admin-rate"
                  size="large"
                  :max="10"
                  :show-score="true"
                  :value="scoreValue"
                  allow-half
                  @change="handleScoreChange"
                />
                <div v-if="scoreError" class="invalid-feedback d-block mt-2">{{ scoreError }}</div>
              </div>
            </div>

            <div class="form-group mb-0">
              <label class="field-label mb-2">Nhận xét tổng quan</label>

              <div v-if="hasAudioComment" class="audio-box">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <div class="audio-box__content">
                    <div class="audio-box__label">
                      <img :src="successIcon" alt="success" class="audio-status-icon">
                      <span>Bản ghi âm nhận xét</span>
                    </div>
                    <audio controls class="audio-player">
                      <source :src="currentHomework.comment" type="audio/wav">
                      Trình duyệt không hỗ trợ phát audio.
                    </audio>
                  </div>

                  <div class="audio-box__actions">
                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" @click="startVoiceRecording">
                      <img :src="voiceIcon" alt="voice" class="voice-icon mr-1">
                      Ghi âm lại
                    </button>
                    <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteRecording">
                      Xóa
                    </button>
                  </div>
                </div>
              </div>

              <div v-else class="comment-input-wrap">
                <el-input
                  :value="commentValue"
                  class="admin-textarea"
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  type="textarea"
                  placeholder="Nhập nhận xét tổng quan (tối thiểu 50 ký tự nếu điểm < 7)"
                  @input="handleCommentInput"
                  @focus="commentTouched = true"
                  @blur="commentTouched = true"
                />
                <button
                  type="button"
                  class="btn btn-light comment-voice-btn"
                  :class="{ recording: isRecording }"
                  @click="startVoiceRecording"
                >
                  <img :src="voiceIcon" alt="voice recording" class="voice-icon">
                  <span>{{ isRecording ? 'Đang ghi âm' : 'Ghi âm' }}</span>
                </button>
              </div>

              <div v-if="commentError" class="invalid-feedback d-block mt-2">{{ commentError }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import voiceIcon from '@/assets/img/voice.png'
import successIcon from '@/assets/img/success-icon.svg'

const AUDIO_EXTENSIONS = ['.mp3', '.wav', '.ogg', '.m4a', '.aac']
const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogv', '.mov', '.m4v', '.3gp', '.mpeg']

export default {
  name: 'MakePronunciation',
  props: {
    currentHomework: {
      type: Object,
      default: function () {
        return {}
      }
    },
    typeCourse: {
      type: Number,
      default: 0
    },
    forceValidate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      voiceIcon: voiceIcon,
      successIcon: successIcon,
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      recordingStartTime: null,
      maxFileSize: 5 * 1024 * 1024,
      minDuration: 10,
      scoreTouched: false,
      commentTouched: false
    }
  },
  computed: {
    mediaType() {
      const url = this.currentHomework && this.currentHomework.student_answer
      if (!url || typeof url !== 'string') return null

      const normalizedUrl = url.split('?')[0].toLowerCase()
      if (VIDEO_EXTENSIONS.some((ext) => normalizedUrl.endsWith(ext))) return 'video'
      if (AUDIO_EXTENSIONS.some((ext) => normalizedUrl.endsWith(ext))) return 'audio'
      return null
    },
    scoreValue() {
      return this.currentHomework && this.currentHomework.score ? this.currentHomework.score : 0
    },
    commentValue() {
      return this.currentHomework && this.currentHomework.comment ? this.currentHomework.comment : ''
    },
    hasAudioComment() {
      return typeof this.commentValue === 'string' && this.commentValue.indexOf('blob:') === 0
    },
    scoreError() {
      if (!this.scoreTouched) return ''
      return (this.currentHomework && this.currentHomework.score) ? '' : 'Vui lòng chấm điểm toàn bài'
    },
    commentError() {
      if (!this.commentTouched) return ''

      const score = this.currentHomework && this.currentHomework.score ? this.currentHomework.score : 0
      if (score > 0 && score < 7) {
        if (!this.commentValue || (typeof this.commentValue === 'string' && this.commentValue.indexOf('blob:') !== 0 && this.commentValue.length < 50)) {
          return 'Nhận xét phải có ít nhất 50 ký tự khi điểm < 7'
        }
      }
      return ''
    }
  },
  watch: {
    forceValidate(newValue) {
      if (newValue) {
        this.scoreTouched = true
        this.commentTouched = true
      }
    }
  },
  created() {
    if (this.currentHomework) {
      if (this.currentHomework.score === undefined || this.currentHomework.score === null) {
        this.$set(this.currentHomework, 'score', 0)
      }
      if (!this.currentHomework.comment) {
        this.$set(this.currentHomework, 'comment', '')
      }
    }
  },
  beforeDestroy() {
    if (this.isRecording && this.mediaRecorder) {
      this.mediaRecorder.stop()
    }
  },
  methods: {
    handleScoreChange(value) {
      this.scoreTouched = true
      this.$set(this.currentHomework, 'score', value)
      this.commentTouched = true
    },
    handleCommentInput(value) {
      this.commentTouched = true
      this.$set(this.currentHomework, 'comment', value)
    },
    resetRecording(stream) {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop())
      }
      this.isRecording = false
      this.recordingStartTime = null
      this.audioChunks = []
    },
    validateRecording(duration, audioBlob) {
      if (duration < this.minDuration) {
        this.$message.error('Thời lượng ghi âm tối thiểu ' + this.minDuration + 's. Bạn đã ghi ' + Math.round(duration) + 's.')
        return false
      }
      if (audioBlob.size > this.maxFileSize) {
        const sizeMb = (audioBlob.size / (1024 * 1024)).toFixed(2)
        this.$message.error('Dung lượng file vượt quá 5MB (' + sizeMb + 'MB). Vui lòng ghi âm ngắn hơn.')
        return false
      }
      return true
    },
    startVoiceRecording() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
        this.$message.error('Trình duyệt không hỗ trợ ghi âm. Vui lòng dùng Chrome/Firefox/Edge.')
        return
      }

      if (this.isRecording) {
        this.stopVoiceRecording()
        return
      }

      this.$message.info('Đang yêu cầu quyền truy cập microphone...')

      navigator.mediaDevices.getUserMedia({ video: false, audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream)
          this.audioChunks = []
          this.recordingStartTime = Date.now()

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.audioChunks.push(event.data)
            }
          }

          this.mediaRecorder.onstop = () => {
            const duration = (Date.now() - this.recordingStartTime) / 1000
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })

            if (!this.validateRecording(duration, audioBlob)) {
              this.resetRecording(stream)
              return
            }

            const url = URL.createObjectURL(audioBlob)
            this.handleCommentInput(url)
            this.resetRecording(stream)

            const sizeMb = (audioBlob.size / (1024 * 1024)).toFixed(2)
            this.$message.success('Ghi âm thành công! Thời lượng: ' + Math.round(duration) + 's, Dung lượng: ' + sizeMb + 'MB')
          }

          this.mediaRecorder.onerror = () => {
            this.$message.error('Lỗi ghi âm. Vui lòng thử lại.')
            this.resetRecording(stream)
          }

          this.isRecording = true
          this.mediaRecorder.start()
          this.$message.info('Đang ghi âm...')
        })
        .catch(() => {
          this.$message.error('Không thể truy cập microphone.')
        })
    },
    stopVoiceRecording() {
      if (this.mediaRecorder) {
        this.mediaRecorder.stop()
      }
    },
    deleteRecording() {
      if (this.currentHomework && this.currentHomework.comment && this.currentHomework.comment.indexOf('blob:') === 0) {
        URL.revokeObjectURL(this.currentHomework.comment)
      }
      this.handleCommentInput('')
      this.$message.success('Đã xóa bản ghi âm.')
    }
  }
}
</script>

<style lang="scss" scoped>
.pronunciation-preview-card,
.pronunciation-score-card {
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem rgba(140, 152, 164, 0.08);
}

.section-heading {
  font-size: 1.05rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #3f4254;
  letter-spacing: 0.04em;
}

.preview-panel,
.score-box {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.preview-panel__title,
.score-box__label,
.field-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3f4254;
  text-transform: uppercase;
}

.preview-panel__body,
.score-box__hint {
  font-size: 0.975rem;
  color: #3f4254;
  line-height: 1.7;
}

.preview-script {
  white-space: pre-line;
}

.score-box__hint {
  text-transform: none;
  color: #7e8299;
  margin-top: 0.25rem;
}

.score-box__rate {
  min-width: 280px;
}

.media-wrap {
  width: 100%;
}

.media-player {
  width: 100%;
  max-height: 320px;
  border-radius: 0.5rem;
  background: #000;
}

.comment-input-wrap {
  position: relative;
}

.comment-voice-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.75rem;
  border-color: #e4e6ef;
  color: #3f4254;
  font-size: 0.95rem;
}

.comment-voice-btn.recording {
  background: #fff4f4;
  border-color: #f64e60;
  color: #f64e60;
}

.voice-icon {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
}

.audio-box {
  padding: 1rem 1.25rem;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
}

.audio-box__content {
  flex: 1 1 auto;
  min-width: 260px;
}

.audio-box__label {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 0.975rem;
  font-weight: 500;
  color: #3f4254;
}

.audio-status-icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
}

.audio-box__actions {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
}

.audio-player {
  width: 100%;
  max-width: 420px;
}

.admin-rate::v-deep .el-rate {
  display: flex;
  align-items: center;
}

.admin-rate::v-deep .el-rate__text {
  margin-left: 0.5rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: #3699ff;
}

.admin-textarea::v-deep .el-textarea__inner {
  border-color: #e4e6ef;
  border-radius: 0.475rem;
  min-height: 110px;
  padding: 0.75rem 0.875rem;
  font-size: 0.975rem;
  line-height: 1.7;
}
</style>
